import { Navigate, useParams } from 'react-router';
import { ContentPage } from './ContentPage';
import { useCollection } from '@/hooks/useCollections';

/**
 * Chooses between list view and item view based on collection metadata.
 * Mirrors reference behavior where singleton collections go straight to the form.
 */
export function CollectionOrItemPage() {
    const { collection } = useParams<{ collection: string }>();
    const { data: collectionInfo, isLoading } = useCollection(collection || '');

    if (isLoading) {
        return (
            <div className="flex h-full items-center justify-center">
                <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
            </div>
        );
    }

    if (!collection) {
        return <ContentPage />;
    }

    if (collectionInfo?.meta?.singleton) {
        return <Navigate to={`/admin/content/${collection}/singleton`} replace />;
    }

    return <ContentPage />;
}